/**
 * Holds a single shopping cart or wish list item.
 */
class CartItem {
	constructor(cartId) {
		this.cartId = cartId;
		this.storeId = null;
		this.product = {};
		this.quantity = 1;
		this.rentalStartDate = null;
		this.rentalEndDate = null;
		this.updatedOnUtc = null;
		this.isFreeShipping = false;
		this.isShipEnabled = false;
		this.additionalShippingCharge = 0;
		this.isTaxExempt = false;
		this.customerEnteredPrice = 0;
		// For kits this hold the id of product attribute values for the kit components
		// selected.
		this.productAttributeValues = [];
		this.productFamilyMemberAttributeValues = [];
		this.selectedProductFamilyMemberProductId = null;
	}
}

export default CartItem;
